<template>
  <div class="confetti-container" v-if="showConfetti">
    <span v-for="n in 120" :key="n" :style="confettiStyle()"></span>
  </div>
</template>

<script>
export default {
  name: "ConfettiContainer",
  props: {
    showConfetti: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      colors: ["#FFD93D", "#6BCB77", "#4D96FF", "#FF6B6B", "#845EC2"], // Original colors from Celebration.vue
    };
  },
  methods: {
    confettiStyle() {
      const size = Math.random() * 8 + 6;
      return {
        left: Math.random() * 100 + "%",
        width: size + "px",
        height: size * 1.4 + "px",
        backgroundColor:
          this.colors[Math.floor(Math.random() * this.colors.length)],
        animationDuration: Math.random() * 3 + 3 + "s",
        animationDelay: Math.random() * 2 + "s",
        transform: `rotate(${Math.random() * 360}deg)`
      };
    },
  },
};
</script>

<style scoped>
.confetti-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10; /* Ensure it's above other elements but below the celebration card */
}

.confetti-container span {
  position: absolute;
  top: -20px;
  opacity: 0.9;
  animation-name: fall, sway;
  animation-timing-function: linear, ease-in-out;
  animation-iteration-count: infinite;
}

@keyframes fall {
  0% { transform: translateY(-20px) rotate(0deg); }
  100% { transform: translateY(150vh) rotate(360deg); }
}

@keyframes sway {
  0% { margin-left: 0; }
  50% { margin-left: 40px; }
  100% { margin-left: 0; }
}
</style>
